import styled from 'styled-components';

export const DivHistoricoImportacao = styled.div`
`;